import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toDateFormatComma } from '~/shared/utils/date'
import { toCroppedImage } from '~/shared/utils/image'
import { DigitalLectureVideoCard } from '~/models/digital-lecture'
import type { ResearchDemandCardDirection } from './types'
import ResearchDemandDetailFilter from './ResearchDemandDetailFilter'

const DEFAULT_DIRECTION_COLOR = '#9dcfff'

const PROJECT_INFO_LABELS = ['Запрос', 'Стадия проекта', 'Регион', 'Готовы предложить']

export default class ResearchDemandDetail extends BaseModel {
  static override constructorName = 'ResearchDemandDetail'

  id: number = 0
  name: string = ''
  slug: string = ''
  'company_name': string = ''
  'company_description': string = ''
  'company_url': string = ''
  'company_image': string = ''
  'main_image': string = ''
  description: string = ''
  link: string = ''
  direction: ResearchDemandCardDirection = { id: '', name: '', color: '' }
  'digital_lecture_videos': DigitalLectureVideoCard[] = []
  filters: ResearchDemandDetailFilter[] = []
  'date_publication': string = ''
  'research_deadline': string = ''
  'applications_count': number = 0
  'likes_count': number = 0
  'views_count': number = 0
  'is_published': boolean = false
  'is_liked': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data, ['digital_lecture_videos', 'filters'])

    this.digital_lecture_videos = convertToArrayModels(data.digital_lecture_videos, DigitalLectureVideoCard)
    this.filters = convertToArrayModels(data.filters, ResearchDemandDetailFilter)

    this.main_image = toCroppedImage(this.main_image)
    this.company_image = toCroppedImage(this.company_image)

    if (this.date_publication) {
      this.date_publication = toDateFormatComma(this.date_publication)
    }

    if (this.research_deadline) {
      this.research_deadline = toDateFormatComma(this.research_deadline)
    }
  }

  get tagColor(): string {
    return this.direction?.color || DEFAULT_DIRECTION_COLOR
  }

  get projectInfo(): ResearchDemandDetailFilter[] {
    return PROJECT_INFO_LABELS
      .map(label => this.filters.find(item => item.filter_name === label))
      .filter((item): item is ResearchDemandDetailFilter => Boolean(item))
  }
}

registerModel(ResearchDemandDetail)
